import React from 'react'
import PropTypes from 'prop-types'
import CustomerDetailContext from "../context/CustomerDetailContext"

CustomerDetailProvider.propTypes = {
    customerInformation: PropTypes.object
}

function CustomerDetailProvider(props) {
    const {customerInformation} = props

    return (
        <div className="CustomerDetailProvider">
            <CustomerDetailContext.Provider
                value={{customerInformation}}
            >
                {props.children}
            </CustomerDetailContext.Provider>
        </div>
    )
}

export default CustomerDetailProvider